import { z } from "zod";
import { OrderSchema } from "../entities";
import { MarketSymbolSchema } from "../branded";
import { OrderStatusGroupSchema } from "../enums";
import { pageOf } from "../primitives";

/** `GET /api/orders`. */
export const ListOrdersQuerySchema = z.object({
  status: OrderStatusGroupSchema.optional(),
  symbol: MarketSymbolSchema.optional(),
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});
export type ListOrdersQuery = z.infer<typeof ListOrdersQuerySchema>;

export const ListOrdersResponseSchema = pageOf(OrderSchema);
export type ListOrdersResponse = z.infer<typeof ListOrdersResponseSchema>;

/** `GET /api/orders/:id` and `POST /api/orders/:id/cancel`. */
export const OrderResponseSchema = OrderSchema;
export type OrderResponse = z.infer<typeof OrderResponseSchema>;
